import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDetailsComponent } from './component/product-details.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, ProductDetailsComponent],
  exports: [ProductDetailsComponent]
})
export class ECommerceModule {}
